import React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../../../theme';

export type AvatarProps = {
  image: string;
  size?: number;
};

const useStyles = makeStyles(() => ({
  root: {
    backgroundImage: 'linear-gradient(#0193E5, #cee8ff)',
    position: 'relative',
    display: 'inline-block',
    borderRadius: '50%',
  },
  imageContainer: {
    position: 'absolute',
    width: 'calc(100% - 8px)',
    height: 'calc(100% - 8px)',
    top: 4,
    left: 4,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: colors.white,
    borderRadius: '50%',
    overflow: 'hidden',
  },
}));

const Avatar = ({ image, size = 60 }: AvatarProps): JSX.Element => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={{
        width: size,
        height: size,
      }}
    >
      <div
        data-testid="image-container"
        className={classes.imageContainer}
        style={{
          backgroundImage: `url(${image})`,
        }}
      />
    </div>
  );
};

export default Avatar;
